export default __webpack_public_path__ + "static/media/Desenvolvimento-Web-PT.43b363c4.jpg";